import {
  AdminTicketScans,
  CouponAssignmentWithPromotion,
  DecryptedTicketScan,
  CouponsApi,
  GetCouponImageRequest,
  GetCouponsForPlayerRequest,
  GetDecryptedTicketScanRequest,
  GetPlayerByLookupRequest,
  GetTicketScansForBarcodeRequest,
  GetTicketScansForPlayerRequest,
  PlayersApi,
  PlayerTicketScans,
  PlayerWithPAMDetails,
  SpinHistoryAdminPage,
  SpinToWinApi,
  TicketScansApi,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getPlayerByLookup = async (playerLookupId: string): Promise<PlayerWithPAMDetails> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PlayersApi)

  const request: GetPlayerByLookupRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playerLookupId,
  }

  return await api.getPlayerByLookup(request)
}

const getPlayerTicketScans = async (
  playerLookupId: string,
  resultStart: number,
  resultEnd: number,
): Promise<PlayerTicketScans> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScansApi)

  const request: GetTicketScansForPlayerRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playerLookupId,
    resultStart,
    resultEnd,
  }

  return await api.getTicketScansForPlayer(request)
}

const getFullTicketScan = async (scanId: string): Promise<DecryptedTicketScan> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScansApi)

  const request: GetDecryptedTicketScanRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    scanId,
  }

  return await api.getDecryptedTicketScan(request)
}

const getPlayerCoupons = async (
  playerLookupId: string,
): Promise<Array<CouponAssignmentWithPromotion>> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CouponsApi)

  const request: GetCouponsForPlayerRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playerLookupId,
  }

  return await api.getCouponsForPlayer(request)
}

const getCouponImage = async (promotionId: string, couponId: string): Promise<Blob> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CouponsApi)

  const request: GetCouponImageRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    promotionId,
    couponId,
  }

  const imageResponse = await api.getCouponImageRaw(request)

  if (!imageResponse.raw.ok) {
    throw new Error('Error fetching image')
  }

  return await imageResponse.raw.blob()
}

const getPlayerSpinHistory = async (
  playerLookupId: string,
  resultStart: number,
  resultEnd: number,
): Promise<SpinHistoryAdminPage> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)

  const request: GetTicketScansForPlayerRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playerLookupId,
    resultStart,
    resultEnd,
  }

  return await api.getSpinHistoryForPlayer(request)
}

const searchTicketScansByBarcode = async (barcode: string): Promise<AdminTicketScans> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScansApi)

  const request: GetTicketScansForBarcodeRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    ticketScanRequest: { barcode },
  }

  return await api.getTicketScansForBarcode(request)
}

export const PlayerServiceAPI = {
  getPlayerByLookup,
  getPlayerTicketScans,
  getFullTicketScan,
  getPlayerCoupons,
  getCouponImage,
  getPlayerSpinHistory,
  searchTicketScansByBarcode,
}
